import styled, { createGlobalStyle } from "styled-components";

import HStack from "shared/components/layout/stack/HStack";

export const AccordionDropdownMultiSelectList = createGlobalStyle`
    .dropdown-list-container-ul {
        border: none;
    }
    .dropdown-list-container{
        position: relative;
        top: 0;
    }
`;

export const DropdownButtonTextRowMultiSelect = styled(HStack)`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
`;
